// @ts-nocheck
export const localeCodes =  [
  "en",
  "nl",
  "de"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_4faae9c2",
      load: () => import("#nuxt-i18n/4faae9c2" /* webpackChunkName: "locale_en_46json_4faae9c2" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_155096c7",
      load: () => import("#nuxt-i18n/155096c7" /* webpackChunkName: "locale_nl_46json_155096c7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_59a8536d",
      load: () => import("#nuxt-i18n/59a8536d" /* webpackChunkName: "locale_de_46json_59a8536d" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2253c71c" /* webpackChunkName: "config_i18n_46config_46ts_2253c71c" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en-GB",
    name: "English"
  },
  {
    code: "nl",
    language: "be-NL",
    name: "Nederlands"
  },
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch"
  }
]
/** client **/

/** client-end **/